import { createContext, useContext } from "react";
import type { CompanySummary } from "@shared-core/data/supplier-portal-adapter";

export interface CompanySummaryState {
  /** What is waiting under *Your company*, or null until it has loaded (or when it could not be). */
  summary: CompanySummary | null;
  isLoading: boolean;
  /** Read it again (an assessment sent, a renewal uploaded, an update started). */
  refresh: () => void;
}

/**
 * *Your company*'s counts and the new-supplier landing, read from suppliers by the shell. A supplier-side read of its
 * own, so the sign-in session knows nothing of assessments (portal sign-in coordinator, 3 Nov).
 */
export const CompanySummaryContext = createContext<CompanySummaryState>({
  summary: null,
  isLoading: false,
  refresh: () => {},
});

export function useCompanySummary(): CompanySummaryState {
  return useContext(CompanySummaryContext);
}
